<template>
  <div class="tab-noraml">
    <div
      v-for="item in options"
      :key="item.value"
      class="tab-noraml__item"
      :class="{ 'tab-noraml__item--active': item.value === value }"
      @click="handleClick(item.value)"
    >
      {{ item.label }}
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'TabNormal'
})

const props = defineProps({
  options: {
    type: Array,
    default: () => []
  },
  value: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['update:value', 'change'])

const handleClick = (val) => {
  if (val !== props.value) {
    emit('update:value', val)
    emit('change', val)
  }
}
</script>

<style lang="scss" scoped>
.tab-noraml {
  flex: 0 0 auto;
  display: flex;
  position: relative;
  background: #f2f3f5;
  z-index: 1;
  padding-bottom: 16px;
  .tab-noraml__item {
    cursor: pointer;
    margin-right: 12px;
    padding: 4px 10px;
    border-radius: 4px;
    background: #e5e6eb;
    font-family: PingFang SC;
    font-size: 12px;
    line-height: 16px;
    color: #323233;
  }
  .tab-noraml__item--active {
    font-weight: 600;
    color: #7a52f4;
    background: #f0dcff;
  }
}
</style>
